/* eslint-disable */


// 页面/组件 一律触发webSocket.js的方法
// webSocket.js方法再去调用vuex存储数据
// 页面/组件 只能去显示vuex的事件 不允许直接调用

let uid = null;//实例对象
let store = null;//实例对象
let wsUrl = null;//ws地址
let webSocket = null;//实例对象
let lockReconnect = false; //是否真正建立连接
let timeout = 60 * 1000; //N秒一次心跳
let timeoutObj = null; //心跳倒计时
let serverTimeoutObj = null; //服务心跳倒计时
let timeOutnum = null; //断开 重连倒计时

// 所有触发的type 客户端发送/服务端返回
let allTypeObj = {
    client: {
        'login':(getData)=>{ //console.error('客户端：发起登录',getData)
            webSocket.send(JSON.stringify(getData));
        },
        'pong':(getData)=>{ //console.error('客户端：pong 答复 ping',getData)
            webSocket.send(JSON.stringify(getData));
        },
        'sendmsg':(getData)=>{//发送消息 //console.error('客户端：发送消息',getData)
            webSocket.send(JSON.stringify(getData));
            store.commit('vuex_addMessage', getData);
        },
        'getallmsg':(getData)=>{//某个好友的所有聊天记录 //console.error('客户端：获取某个好友的所有聊天记录',getData)
            webSocket.send(JSON.stringify(getData));
        },
        'friendmsg':(getData)=>{//接收到好友发来的消息 //console.error('客户端：接收到好友发来的消息',getData)
            webSocket.send(JSON.stringify(getData));
        },
        'getallfriend':(getData)=>{//获取好友列表 //console.error('客户端：获取好友列表',getData)
            webSocket.send(JSON.stringify(getData));
        },
        'newfriend':(getData)=>{//服务器推送新好友 //console.error('客户端：服务器推送新好友',getData)
            webSocket.send(JSON.stringify(getData));
        },
    },
    server: {
        'onconnect':(getData)=>{//console.error('服务器：连接成功', getData);

        },
        'login': (getData) => {//console.error('服务器：登录成功 -> 获取最近好友列表', getData)
            store.commit('vuex_setMyInfo', getData);
            sendWebSocketMessage({type: 'getallfriend'})
        },
        'ping': (getData) => {// console.error('服务器：ping 召唤 pong', getData)
            sendWebSocketMessage({type: 'pong'})
        },
        'sendmsg': (getData) => {//发送消息 console.error('服务器：发送成功', getData)
            let {towhoid,towho,timestamp} = getData?.data||{};
            if( towhoid && towho && timestamp){

                let server_back ={
                    data:{
                        towhoid,
                        towho,
                        timestamp,
                        setType:"msgState",// 要修改的字段： msgState 消息状态
                        setValue:'sss',// 要修改的值
                    }
                }

                store.commit('vuex_setMessage',server_back);
            }

        },
        'getallmsg': (getData) => {//某个好友的所有聊天记录// console.error('服务器：某个好友的所有聊天记录', getData)
            store.commit('vuex_intUserChatItem', getData);
        },
        'friendmsg': (getData) => {//接收到好友发来的消息
            console.error('服务器：好友发来的消息', getData)
            store.commit('vuex_addMessage', getData);
        },
        'getallfriend': (getData) => {//获取好友列表// console.error('服务器：下发最近好友列表 -> 客户端请更新最近好友列表', getData)
            store.commit('vuex_setRecentUserList',getData);
        },
        'newfriend': (getData) => {//服务器推送新好友
            console.error('服务器：新的好友', getData)
            store.commit('vuex_addUser', getData);
        },
    },
}

const test = ()=>{
    store.commit('vuex_addMessage', {type:"",data:{

            "name": "180000000",
            "id": "5",
            "content": "213",
            "time": "22:2",
            'fromwho':"18050996693",
            'fromwhoid':"5",
            'msgState':"00",
        }});
}

//开启心跳
const start = () => {
    timeoutObj && clearTimeout(timeoutObj);
    serverTimeoutObj && clearTimeout(serverTimeoutObj);
    timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        if (webSocket.readyState == 1) {
            //如果连接正常 ping/pong
            // sendWebSocketMessage({type: 'pong'})
        } else {
            console.error("链接异常：",webSocket.readyState)
            //否则重连
            reconnect();
        }
        serverTimeoutObj = setTimeout(function () {
            console.error("服务器超时：关闭")
            //超时关闭
            // webSocket.close();
        }, timeout);
    }, timeout);
}

//重新连接
const reconnect = () => {
    if (lockReconnect) {
        return;
    }
    lockReconnect = true;
    //没连接上会一直重连，设置延迟避免请求过多
    timeOutnum && clearTimeout(timeOutnum);
    timeOutnum = setTimeout(function () {
        //新连接
        initWebSocket();
        lockReconnect = false;
    }, 1000);
}

//重置心跳
const reset = () => {
    //清除时间 重置心跳
    clearTimeout(timeoutObj);
    clearTimeout(serverTimeoutObj);
    //重启心跳
    start();
}

// 发消息
const sendWebSocketMessage = (getData) => {
    if (webSocket.readyState === WebSocket.OPEN) {
        let clientType = allTypeObj['client']
        if (clientType[getData.type]) {
            clientType[getData.type](getData)
        } else {
            console.log('超出客户端预留，继续发送',getData)
            webSocket.send(JSON.stringify(getData));
        }
    } else {
        console.error('WebSocket 未打开');
    }
}

// //断开连接
// const socketClose = () => {
//     //WebSocket对象也有发送和关闭的两个方法，只需要在自定义方法中分别调用send()和close()即可实现。
//     webSocket.close();
// }

// 初始化
async function initWebSocket(){
    if ("WebSocket" in window) {
        webSocket = new WebSocket(wsUrl);
        // 异常
        webSocket.onerror = (errorRes) => {
            console.error('异常', errorRes)
            setTimeout(() => {
                initWebSocket();
            }, 1000)
            reconnect();
        };

        //服务器返回的数据
        webSocket.onmessage = (e) => {
            let getData = JSON.parse(e.data)

            // 你可以通过 app.config.globalProperties 来分发消息到所有组件
            // 也可以 用window自定义事件进行触发和监听
            // 但通常，更好的做法是使用 Vuex 或 Event Bus
            // 这里只是简单打印消息

            // //window自定义事件
            // window.dispatchEvent(
            //     new CustomEvent("messageWS", {
            //         detail: {
            //             data: JSON.parse(e?.data),
            //         },
            //     })
            // );
            // // 然后，您可以在其他地方监听此事件
            // window.addEventListener("messageWS", function(event) {
            //     console.log(event.detail.data);
            // });

            let serverType = allTypeObj['server']

            if (serverType[getData.type]) {
                serverType[getData.type](getData)
            } else {
                console.error("服务端的数据不在预留的范围")
            }

            reset();
        };

        // 连接关闭
        webSocket.onclose = (event) => {
            store.commit('vuex_setManyData', {
                recent_userList:[],
                allChat_recordList: {},
                this_roomId:"",
                this_roomChatItem: {},
            });
            if (event.wasClean) {
                console.log('WebSocket 连接完全关闭, code:', event.code, 'reason:', event.reason);
            } else {
                console.error('WebSocket 连接已死');
            }
            reconnect();
        };

        //建立连接
        webSocket.onopen = () => {
            // 这里可以发送初始消息或者做其他事情
            console.log('WebSocket is open now.');
            sendWebSocketMessage({type: 'login', data: {'uid': uid}})
            start();
        };

    } else {
        alert("您的浏览器不支持websocket，请更换Chrome或者Firefox")
        return false
    }
}

function install(app,getStore, options) {
    if (options.uid) {
        uid = options.uid    // uid
        store = getStore    // 初始化 store
        wsUrl = options.url    // 初始化 store
        initWebSocket();    // 初始化 WebSocket
        // 将 WebSocket 实例添加到全局属性中
        // app.config.globalProperties.$webSocket = webSocket;
        // // 将 断开连接 全局属性中
        // app.config.globalProperties.$socketClose = socketClose;
        // 如果需要，你可以添加额外的功能，比如发送消息的方法
        // app.config.globalProperties.$sendWebSocketMessage = sendWebSocketMessage;
    }else{alert("缺少用户uid")}
}

export default {
    install,
    sendWebSocketMessage,
    test
}
